import { render } from "./Fight.vue?vue&type=template&id=ee5fe1ea"
import script from "./Fight.vue?vue&type=script&lang=js"
export * from "./Fight.vue?vue&type=script&lang=js"

import "./Fight.vue?vue&type=style&index=0&id=ee5fe1ea&lang=css"
script.render = render

export default script